import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { catchError, map, switchMap, take, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import * as listingActions from '../actions/listing.actions';
import { ListingService } from '../services/listing.service';
import * as jobsActions from '../actions/jobs.actions';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material';
import { JobListing } from '../models/listing.model';

@Injectable()
export class ListingEffects {
  @Effect()
  LoadListing$: Observable<Action> = this.actions$.pipe(
    ofType<listingActions.LoadListing>(
      listingActions.ListingActionTypes.LoadListing
    ),
    switchMap(action =>
      this.listingService.getJobListing(action.payload.jobId).pipe(
        map(
          (response: any) =>
            new listingActions.UseListing({ listing: response })
        ),
        catchError(errors =>
          of(new listingActions.ListingActionFail({ error: errors }))
        )
      )
    )
  );

  @Effect()
  SaveListing$: Observable<Action> = this.actions$.pipe(
    ofType<listingActions.SaveListing>(
      listingActions.ListingActionTypes.SaveListing
    ),
    switchMap(action =>
      this.listingService
        .createUpdateJobListing(action.payload.jobId, action.payload.listing)
        .pipe(
          map(
            (response: any) =>
              new listingActions.UseListing({ listing: response })
          ),
          catchError(errors =>
            of(
              new listingActions.ListingActionFail({
                error: errors,
              })
            )
          )
        )
    )
  );

  @Effect()
  ShowPreview$: Observable<Action> = this.actions$.pipe(
    ofType<jobsActions.ShowPreview>(jobsActions.JobsActionTypes.ShowPreview),
    switchMap(action =>
      this.listingService
        .createUpdateJobListing(action.payload.job.id, action.payload.listing)
        .pipe(
          switchMap((response: JobListing) => {
            return of(
              new listingActions.SaveListingSuccess({
                listing: response,
              })
            );
          }),
          tap((r: any) => {
            if (action.payload.showUpdateNotification) {
              this._translate
                .get('job_snackbar_job_update_success')
                .pipe(take(1))
                .subscribe(text => {
                  this._snackBar.open(text, null, {
                    duration: 3000,
                  });
                });
            }
            window.open(`${environment.jobShareUrl}${action.payload.job.id}/`);
          }),
          catchError(errors =>
            of(new jobsActions.JobActionFail({ error: errors }))
          )
        )
    )
  );

  constructor(
    private actions$: Actions,
    private _translate: TranslateService,
    private _snackBar: MatSnackBar,
    private listingService: ListingService
  ) {}
}
